import { Injectable, EventEmitter } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginData } from '../models/login.model';
import { BusinessUser } from '../models/business-user.model';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  private ak = '7f51e1c5f3027479ff324aca35f0db0c';

  public authenticated: EventEmitter<boolean> = new EventEmitter<boolean>();

  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  constructor(
    private httpClient: HttpClient
  ) { }

  public login(email: String, passwd: String): Observable<LoginData> {
    return this.httpClient.post<LoginData>(
      `${this.apiUrl}/api/oauth/client/login`,
      {
        email: email,
        password: passwd
      },
      this.httpOptions
    )
  }

  public perfil(): Observable<LoginData>{
    return this.httpClient.get<LoginData>(
      `${this.apiUrl}/api/oauth/client/me`,
      this.httpOptions
    );
  }

  public logUserIn(login: LoginData) {
    localStorage.setItem(this.ak, JSON.stringify({
      at: btoa(login.access_token),
      tt: btoa(login.token_type),
      op: btoa(JSON.stringify(login.user))
    }));
    this.authenticated.emit(true);
  }

  public logout() {
    localStorage.removeItem(this.ak);
    this.authenticated.emit(false);
  }

  public get isLoggedIn() : boolean {
    return localStorage.getItem(this.ak) !== null
  }

  public get tokenData() : string {
    return this.storageInfo.token_type + " " + this.storageInfo.access_token
  }

  public get user(): BusinessUser {
    return this.storageInfo.user;
  }

  private get storageInfo(): any {
    const storage = localStorage.getItem(this.ak);
    const storageJSON = JSON.parse(storage);

    if(!storageJSON) {
      return {
        access_token: '',
        token_type: '',
        user: {},
      }
    }

    return {
      access_token: atob(storageJSON.at),
      token_type: atob(storageJSON.tt),
      user: JSON.parse(atob(storageJSON.op)),
    }
  }
}
